import {memo, forwardRef, useMemo} from "react";
import {Box} from "@chakra-ui/react";
import {calculateDiagramBounds} from "../utility/diagramBounds";
import {Camera} from "../utility/camera";
import {DiagramContent} from "./view/DiagramContent";
import {ClientDiagram} from "../utility/types";
import type {SwimlaneConfig} from "../index";

type DiagramExportRendererProps = {
  diagram: ClientDiagram;
  padding?: number;
  showBackgroundGrid?: boolean;
  showSwimlanes?: boolean;
  swimlanes?: SwimlaneConfig[];
};

/**
 * Component that renders a clean version of the diagram for export.
 * This excludes UI elements like selection borders, hover states, UI controls, etc.
 */
export const DiagramExportRenderer = memo(
  forwardRef<HTMLDivElement, DiagramExportRendererProps>(
    ({diagram, padding = 2, showBackgroundGrid = true, showSwimlanes = false, swimlanes}, ref) => {
      const bounds = useMemo(() => calculateDiagramBounds(diagram, padding), [diagram, padding]);
      const exportCamera = useMemo(() => Camera.forExport(bounds.size, bounds.center), [bounds.center, bounds.size]);

      return (
        <Box ref={ref} width={`${bounds.size.x}px`} height={`${bounds.size.y}px`} position="relative" overflow="hidden">
          <DiagramContent
            diagram={diagram}
            camera={exportCamera}
            showBackgroundGrid={showBackgroundGrid}
            showSwimlanes={showSwimlanes}
            swimlanes={swimlanes}
          />
        </Box>
      );
    },
  ),
);
